import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: "We had tried 'taking turns' three times before. It always fell apart by night two. This was different because the blocks were fixed and the handoff script meant we didn't have to talk — we just followed the card. Night three I slept 5 hours straight for the first time in four months.",
  name: 'Mariana T.',
  detail: 'Mom of a 4-month-old, back to work in 2 weeks'
}, {
  quote: "I was the one who always ended up doing everything because 'asking' felt like starting a fight. The copy-paste texts alone were worth it. I sent one at 9pm and my husband actually set an alarm. No argument. No explanation. Just… it worked.",
  name: 'Jessie R.',
  detail: 'First-time mom, 6 weeks postpartum'
}, {
  quote: "Honestly I was skeptical of a $6 PDF. But I was also desperate. The anti-resentment rules are the part nobody talks about — having something printed that says 'no score-keeping' meant I could point to it instead of saying it myself. That changed everything.",
  name: 'Daniela M.',
  detail: 'Mom of twins, 3 months old'
}];
export function TestimonialsSection() {
  return <section className="py-20 px-5 max-w-2xl mx-auto" data-id="element-219">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8
    }} data-id="element-220">
        <p className="text-gold-400 uppercase tracking-[0.2em] text-xs font-semibold mb-3 text-center" data-id="element-221">
          Real parents. Real nights.
        </p>
        <h2 className="font-serif text-3xl text-cream-50 mb-12 text-center" data-id="element-222">
          What happened after 3 nights
        </h2>

        <div className="space-y-6" data-id="element-223">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: i * 0.15
        }} className="bg-[#1a2540] border border-white/8 rounded-2xl p-6" data-id="element-224">
              {/* Stars */}
              <div className="flex gap-1 mb-4" data-id="element-225">
                {[...Array(5)].map((_, s) => <Star key={s} className="w-3.5 h-3.5 text-gold-400 fill-current" data-id="element-226" />)}
              </div>

              {/* Quote */}
              <p className="text-cream-100/85 leading-relaxed text-sm sm:text-base mb-5 italic" data-id="element-227">
                "{t.quote}"
              </p>

              {/* Attribution */}
              <div className="flex items-center gap-3" data-id="element-228">
                <div className="w-8 h-8 rounded-full bg-gold-400/20 border border-gold-400/30 flex items-center justify-center text-gold-400 font-serif font-bold text-sm flex-shrink-0" data-id="element-229">
                  {t.name[0]}
                </div>
                <div data-id="element-230">
                  <p className="text-cream-50 font-semibold text-sm" data-id="element-231">
                    {t.name}
                  </p>
                  <p className="text-cream-100/40 text-xs" data-id="element-232">{t.detail}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </motion.div>
    </section>;
}